<template>
	<div class="Internet">
		<div class="box-1">
			<div>
				<h3>Box</h3>
				<p>
					{{ $t("internet.box") }}
				</p>
			</div>
		</div>
		<div class="box-3">
			<img src="../../assets/imgs/Box-5.png" alt="" />
			<div>
				<h3>{{ $t("internet.installation") }}</h3>
				<p>
					{{ $t("internet.label") }}
				</p>
			</div>
		</div>
		<div class="box-4">
			<h3>{{ $t("internet.Support") }}</h3>
			<p>
				{{ $t("internet.SupportLabel") }}
			</p>
		</div>
		<ul class="box-5">
			<li v-for="(item, index) in boxList" :key="index">
				<img :src="item.url" />
				<h4>{{ item.title }}</h4>
				<p>{{ item.label }}</p>
			</li>
		</ul>
		<!-- <div class="box-6">
      一点一滴，推动设备智能化。
    </div> -->
	</div>
</template>
<script>
export default {
	data() {
		return {
			titleImg: [
				{
					url: require("../../assets/imgs/FBox1.png"),
					label: "标准型",
				},
				{
					url: require("../../assets/imgs/FBox2.png"),
					label: "轻量型",
				},
			],
			boxList: [
				{
					url: require("../../assets/imgs/check.png"),
					title: this.$t("internet.boxList.time"),
					label: this.$t("internet.boxList.mobile"),
				},
				{
					url: require("../../assets/imgs/Open.png"),
					title: this.$t("internet.boxList.open"),
					label: this.$t("internet.boxList.openLabel"),
				},
				{
					url: require("../../assets/imgs/Cloud.png"),
					title: this.$t("internet.boxList.Cloud"),
					label: this.$t("internet.boxList.CloudLabel"),
				},
				{
					url: require("../../assets/imgs/Data.png"),
					title: this.$t("internet.boxList.Storage"),
					label: this.$t("internet.boxList.StorageLabel"),
				},
				{
					url: require("../../assets/imgs/Download.png"),
					title: this.$t("internet.boxList.Remote"),
					label: this.$t("internet.boxList.RemoteLabel"),
				},
				{
					url: require("../../assets/imgs/Safe.png"),
					title: this.$t("internet.boxList.Reliable"),
					label: this.$t("internet.boxList.ReliableLabel"),
				},
			],
		};
	},
};
</script>
<style lang="scss">
.Internet {
	.Internet-title {
		display: flex;
		justify-content: center;
		padding: 16px 0;
		li {
			margin: 0 24px;
			padding: 12px 24px;
			border: 1px solid #fff;
			transition: 0.5s all linear;
			&:hover {
				border: 1px solid #ccc;
				border-radius: 4px;
				box-sizing: border-box;
				transform: scale3d(1.1, 1.1, 1.1);
			}
			div {
				text-align: center;
				margin: 10px 0;
			}
		}
	}
	.box-1 {
		height: 780px;
		text-align: center;
		background: url("../../assets/imgs/Box-1.jpg") no-repeat;
		color: #fff;
		padding: 40px;
		background-position: center;
		div {
			width: 682px;
			margin: 0 auto;
			text-align: left;
			line-height: 30px;
			font-size: 16px;
			text-indent: 2em;
		}
	}
	.box-3 {
		display: flex;
		justify-content: center;
		margin: 120px 0;
		align-items: center;
		div {
			width: 500px;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 0 40px;
			p {
				font-size: 16px;
				line-height: 30px;
				width: 320px;
				color: #666666;
				margin-bottom: 60px;
			}
			a {
				align-self: flex-end;
				font-size: 20px;
				color: #266bcc;
				text-decoration: none;
			}
		}
	}
	.box-4 {
		height: 443px;
		text-align: center;
		background: url("../../assets/imgs/Box-6.png") no-repeat;
		padding: 40px;
		background-position: center;
		p {
			color: #666;
		}
	}
	h3 {
		font-size: 48px;
		text-align: center;
		font-weight: inherit;
		margin-bottom: 38px;
	}
	.box-5 {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		margin: 40px auto;
		li {
			width: 400px;
			align-self: center;
			padding: 0 60px;
			text-align: center;
			margin-top: 40px;
			h4 {
				margin-top: 14px;
				font-size: 24px;
				margin-bottom: 19px;
				color: #333333;
			}
			p {
				color: #666666;
				font-size: 16x;
				line-height: 30px;
			}
		}
	}
	.box-6 {
		background: url("../../assets/imgs/Box-8.png") no-repeat;
		height: 800px;
		line-height: 800px;
		color: #ffffff;
		font-size: 48px;
		font-weight: inherit;
		text-align: center;
	}
}
</style>
